import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {onMobileLogin, onRegister, onUserLogin,onForget} from "@/api/user";
import {GetAllArea} from "@/api/common";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: {},
    area: [],
    logo: ''
  },
  getters: {
    getToken: state => state.token,
    getUser: state => state.userInfo,
    getArea: state => state.area,
    getLogo: state => state.logo,
  },
  mutations: {
    setToken(state, val) {
      state.token = val
    },

    setUser(state, val) {
      state.userInfo = val
    },

    clearLogin(state, val) {
      state.token = ''
      state.userInfo = {}
    },

    setArea(state, val) {
      state.area = val
    },

    setLogo(state, val) {
      state.logo = val
    }
  },
  actions: {
    // 获取地区
    getArea({commit}) {
      Promise.try(() => {
        return GetAllArea()
      }).then(res => {
        commit('setArea', res.data)
      })
    },

    // 登陆
    onLogin({commit}, {ruleForm, type}) {
      return new Promise(async (resolve, reject) => {
        try {
          const request = {
            0: onRegister,
            1: onMobileLogin,
            2: onUserLogin,
						3: onForget,
          }[type]

          const res = await request(ruleForm)
          const {data} = res
					if(type!=3){ // 找回密码需要手动登录
						commit('setToken', data.userinfo.token)
						commit('setUser', {
							username: data.userinfo.username,
							email: data.userinfo.email,
							mobile: data.userinfo.mobile,
							avatar: data.userinfo.avatar,
							is_vip: data.userinfo.is_vip,
							vip_type: data.userinfo.vip_type,
							vip_days: data.userinfo.vip_days,
							vip_expire_time: data.userinfo.vip_expire_time,
							user_id: data.userinfo.user_id,
						})
					}
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },

    // 退出登陆
    layout({commit}) {
      return new Promise((resolve, reject) => {
        commit('clearLogin')
        resolve()
      })
    }
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      storage:window.localStorage,
      //存储的 key 的值
      key: 'store',
      reducer: (state, data) => ({
        token: state.token,
        userInfo: state.userInfo
      })
   }),
   createPersistedState({
     storage: window.sessionStorage,
     key: 'area',
     reducer: (state, data) => ({
       area: state.area
     })
   })
  ]
})
